module.exports = __webpack_public_path__ + "media/images/vp/icon.addtask.black-e8b2c42fafc9c6cbd4c420404ca36d5f.svg";